export default __webpack_public_path__ + "static/media/admission.190ee5af.jpg";